module.exports = __webpack_public_path__ + "img/add_sub_help.2a2322a7.png";